import axios from "axios";
import { initializeAxiosMockAdapter, isMockEnabled } from "@/mock/mock.config";

export const LS_CSRF_HASH = "CsrfTokenHash";
export const LS_CSRF_EXPIRY = "CsrfTokenExpiry";

export let baseURL = "";
if (typeof window !== "undefined") {
  const { hostname, protocol } = window.location;
  baseURL = `${protocol}//${hostname}/`;
}

const isCsrfTokenExpired = () => {
  if (typeof window === "undefined") return true;
  const expiredDate = new Date(
    Number(window.localStorage.getItem(LS_CSRF_EXPIRY))
  );
  const differenceInTime = expiredDate.getTime() - new Date().getTime();
  return differenceInTime <= 0;
};

let instance = axios.create({
  baseURL,
  headers: {
    "Content-type": "application/json",
  },
  withCredentials: true,
});

// Restore cached CSRF token so page refreshes don't always trigger a fetch
if (typeof window !== "undefined") {
  const cachedHash = window.localStorage.getItem(LS_CSRF_HASH);
  if (cachedHash && !isCsrfTokenExpired()) {
    instance.defaults.headers.common["X-CSRF-TOKEN"] = cachedHash;
  }
}

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    if (error.response && error.response.status === 401) {
      window.location = `${baseURL}user/logout?message=genericSignOut`;
    }
    return Promise.reject(error);
  }
);

let csrfFetchPromise = null;

instance.interceptors.request.use(
  async function (config) {
    if (
      !instance.defaults.headers.common["X-CSRF-TOKEN"] ||
      isCsrfTokenExpired()
    ) {
      if (!csrfFetchPromise) {
        csrfFetchPromise = axios.get("/api/CSRFToken").finally(() => {
          csrfFetchPromise = null;
        });
      }
      const {
        data: { hash },
      } = await csrfFetchPromise;
      const expiry = new Date();
      expiry.setHours(expiry.getHours() + 1);
      expiry.setMinutes(expiry.getMinutes() + 30);
      window.localStorage.setItem(LS_CSRF_EXPIRY, expiry.getTime());
      window.localStorage.setItem(LS_CSRF_HASH, hash);
      instance.defaults.headers.common["X-CSRF-TOKEN"] = hash;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

if (isMockEnabled()) {
  initializeAxiosMockAdapter(instance);
}

export const http = instance;
